// Module
var code = "<div class=\"sb-subbar-mode md-toolbar-tools\" ng-transclude></div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/states/sablono/directives/sbSubbarMode/sbSubbarMode.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;